import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import FeedbackButton from '@helsenorge/core-cms/feedbackbutton';
import FeedbackModal from '@helsenorge/core-cms/feedbackmodal';
import styles from './feedbackmodal-wrapper.module.scss';
const FeedbackModalWrapper = props => {
    const [isVisible, setIsVisible] = useState(true);
    const handleClose = (id) => {
        setIsVisible(false);
        props.onClose(id);
    };
    if (!isVisible) {
        return null;
    }
    return (_jsxs(FeedbackModal, { title: props.survey.title, closeButtonText: props.survey.closeButtonText, onClose: () => handleClose(props.survey.id), buttons: _jsxs(_Fragment, { children: [_jsx(FeedbackButton, { onClick: () => {
                        window.location.href = props.survey.surveyUrl;
                    }, variant: "outline", type: "submit", value: "accept", children: props.survey.acceptButtonText }), _jsx(FeedbackButton, { variant: "borderless", type: "submit", value: "deny", children: props.survey.declineButtonText })] }), children: [props.survey.text, props.survey.disclaimerText && (_jsx("p", { className: styles.disclaimertext, children: props.survey.disclaimerText.replace('{url}', props.survey.surveyUrl) }))] }));
};
export default FeedbackModalWrapper;
